import React, { useEffect } from "react";
import { Layout, Select, DatePicker, Space, Button, Card } from "antd";
import CardMonitor from "../../components/dashboard/CardMonitor";
import { TeamOutlined, CloudDownloadOutlined, FilterOutlined, ReloadOutlined } from "@ant-design/icons";
import { postProgram, postDashboard } from "../../services/program";
import CountUp from "react-countup";
import VMSList from "../../components/dashboard/VMSList";
import Download from "../../components/Download";
const { Content: AntdContent } = Layout;
const { RangePicker } = DatePicker;
import {
  getVMSService,
  getVMSDestinationService,
  getVMSNotExitService,
  getVMSTodayService,
} from "../../services/vms";
import { i } from "mathjs";

const ContentComp = ({ colorBgContainer, borderRadiusLG }) => {
  const [template, setTemplate] = React.useState([]);
  const [data, setData] = React.useState({});
  const [totalVMS, setTotalVMS] = React.useState([]);
  const [todayVMS, setTodayVMS] = React.useState([]);
  const [notExitVMS, setNotExitVMS] = React.useState([]);
  const [dataList, setDataList] = React.useState({});
  const [dateRange, setDateRange] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [isAutoUpdate, setIsAutoUpdate] = React.useState(true);

  const mapToKeyValue = (input) => {
    return input?.map((item) => {
      return {
        [item.destination]: item.objective,
      };
    });
  };

  // ฟังก์ชันสำหรับการกรองข้อมูลตามช่วงวันที่
  const handleDateRangeChange = (dates) => {
    setDateRange(dates);
    setError(null); // ล้าง error เมื่อมีการเปลี่ยนแปลง dateRange
    
    // อัปเดตสถานะ auto update
    if (dates && dates[0] && dates[1]) {
      setIsAutoUpdate(false);
    } else {
      setIsAutoUpdate(true);
    }
  };

  // ฟังก์ชันสำหรับรีเซ็ต filter
  const handleResetFilter = () => {
    setDateRange(null);
    setError(null); // ล้าง error เมื่อรีเซ็ต filter
    setIsAutoUpdate(true); // เปิดการอัปเดตอัตโนมัติเมื่อรีเซ็ต
  };

  // ฟังก์ชันสำหรับการกรองข้อมูลทันทีเมื่อเลือกวันที่
  const handleApplyFilter = () => {
    if (dateRange && dateRange[0] && dateRange[1]) {
      setError(null); // ล้าง error เมื่อเริ่มกรองข้อมูล
      setIsAutoUpdate(false); // ปิดการอัปเดตอัตโนมัติเมื่อกรองข้อมูล
      // ข้อมูลจะถูกอัปเดตอัตโนมัติผ่าน useEffect
      console.log("Applying filter for date range:", dateRange[0].format('YYYY-MM-DD'), "to", dateRange[1].format('YYYY-MM-DD'));
    }
  };



  async function getDistination(templates) {
    try {
      // ถ้ามี dateRange ให้ใช้ dateRange ในการกรอง
      let startDate = null;
      let endDate = null;
      
      if (dateRange && dateRange[0] && dateRange[1]) {
        startDate = dateRange[0].format('YYYY-MM-DD');
        endDate = dateRange[1].format('YYYY-MM-DD');
      }
      
      for (const key of templates) {
        const { res, error } = await postDashboard({
          filterDestination: key,
          site_uuid: JSON.parse(localStorage.getItem("site")),
          mode: 1,
          startDate: startDate,
          endDate: endDate,
        });

        if (!error) {
          setData((prev) => ({
            ...prev,
            [key]: res["data"],
          }));
        } else {
          setError(`เกิดข้อผิดพลาดในการโหลดข้อมูลสำหรับ ${key}`);
        }
      }
    } catch (error) {
      console.error("Error in getDistination:", error);
      setError("เกิดข้อผิดพลาดในการโหลดข้อมูลปลายทาง");
    }
  }

  useEffect(() => {
    async function getProgram() {
      setLoading(true);
      try {
        const { res, error } = await postProgram({
          site_uuid: JSON.parse(localStorage.getItem("site")),
        });
        if (error) {
          //console.log("Error:", res);
          setError("เกิดข้อผิดพลาดในการโหลดข้อมูลโปรแกรม");
          return;
        }
        if (res["template"] === undefined) {
          setError("ไม่พบข้อมูลเทมเพลตโปรแกรม");
          return;
        }
        setTemplate(mapToKeyValue(res["template"]));
        await getDistination(res?.template.map((item) => item.destination));
        for (const items of res["template"]) {
          // ถ้ามี dateRange ให้ใช้ dateRange ในการกรอง
          let startDate = null;
          let endDate = null;
          
          if (dateRange && dateRange[0] && dateRange[1]) {
            startDate = dateRange[0].format('YYYY-MM-DD');
            endDate = dateRange[1].format('YYYY-MM-DD');
          }
          
          const buffer = await getVMSDestinationService(
            JSON.parse(localStorage.getItem("site")),
            items.destination,
            startDate,
            endDate
          );

          if (buffer) {
            setDataList((prev) => ({
              ...prev,
              [items.destination]: buffer,
            }));
          } else {
            setError(`เกิดข้อผิดพลาดในการโหลดข้อมูลสำหรับ ${items.destination}`);
          }
        }
      } catch (error) {
        console.error("Error in getProgram:", error);
        setError("เกิดข้อผิดพลาดในการโหลดข้อมูลโปรแกรม");
      } finally {
        setLoading(false);
      }
    }

    async function fetchData() {
      setLoading(true);
      try {
        // ถ้ามี dateRange ให้ใช้ dateRange ในการกรอง
        let startDate = null;
        let endDate = null;
        
        if (dateRange && dateRange[0] && dateRange[1]) {
          startDate = dateRange[0].format('YYYY-MM-DD');
          endDate = dateRange[1].format('YYYY-MM-DD');
        }
        
        const { res, error } = await postDashboard({
          filterDestination: "",
          site_uuid: JSON.parse(localStorage.getItem("site")),
          mode: 0,
          startDate: startDate,
          endDate: endDate,
        });

        if (!error) {
          setData((prev) => ({
            ...prev,
            ["ผู้มาติดต่อ"]: res["enter"],
            ["ยังอยู่ในพื้นที่"]: res["internal"],
          }));
        } else {
          setError("เกิดข้อผิดพลาดในการโหลดข้อมูลผู้ติดต่อ");
        }
      } catch (error) {
        console.error("Error in fetchData:", error);
        setError("เกิดข้อผิดพลาดในการโหลดข้อมูล");
      } finally {
        setLoading(false);
      }
    }

    async function executeTasks() {
      await fetchData();
      await getProgram();
    }
    executeTasks();
  }, [dateRange]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // ถ้ามี dateRange ให้ใช้ dateRange ในการกรอง
        let startDate = null;
        let endDate = null;
        
        if (dateRange && dateRange[0] && dateRange[1]) {
          startDate = dateRange[0].format('YYYY-MM-DD');
          endDate = dateRange[1].format('YYYY-MM-DD');
        }
        
        const result = await getVMSNotExitService(
          JSON.parse(localStorage.getItem("site")),
          startDate,
          endDate
        );
        if (result) {
          setNotExitVMS(result);
        } else {
          setError("เกิดข้อผิดพลาดในการโหลดข้อมูล VMS ที่ยังไม่ออก");
        }

        const today = await getVMSTodayService(
          JSON.parse(localStorage.getItem("site")),
          startDate,
          endDate
        );
        if (today) {
          setTodayVMS(today);
        } else {
          setError("เกิดข้อผิดพลาดในการโหลดข้อมูล VMS วันนี้");
        }
      } catch (error) {
        console.error("Error in fetchData:", error);
        setError("เกิดข้อผิดพลาดในการโหลดข้อมูล VMS");
      } finally {
        setLoading(false);
      }
    };
    
    // เรียกใช้ fetchData ทันที
    fetchData();
    
    // ตั้ง interval เฉพาะเมื่อไม่มี dateRange (ไม่มีการกรอง)
    let interval;
    if (!dateRange || !dateRange[0] || !dateRange[1]) {
      setIsAutoUpdate(true);
      interval = setInterval(() => {
        fetchData();
      }, 15 * 1000);
    } else {
      setIsAutoUpdate(false);
    }
    
    // Cleanup interval เมื่อ component unmount
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [localStorage.getItem("site"), dateRange]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // ถ้ามี dateRange ให้ใช้ dateRange ในการกรอง
        let startDate = null;
        let endDate = null;
        
        if (dateRange && dateRange[0] && dateRange[1]) {
          startDate = dateRange[0].format('YYYY-MM-DD');
          endDate = dateRange[1].format('YYYY-MM-DD');
        }
        
        const result = await getVMSService(
          JSON.parse(localStorage.getItem("site")),
          startDate,
          endDate
        );
        if (result) {
          setTotalVMS(result);
        } else {
          setError("เกิดข้อผิดพลาดในการโหลดข้อมูล VMS ทั้งหมด");
        }
      } catch (error) {
        console.error("Error in fetchData:", error);
        setError("เกิดข้อผิดพลาดในการโหลดข้อมูล VMS ทั้งหมด");
      } finally {
        setLoading(false);
      }
    };
    
    // เรียกใช้ fetchData ทันที
    fetchData();
    
    // ตั้ง interval เฉพาะเมื่อไม่มี dateRange (ไม่มีการกรอง)
    let interval;
    if (!dateRange || !dateRange[0] || !dateRange[1]) {
      setIsAutoUpdate(true);
      interval = setInterval(() => {
        fetchData();
      }, 15 * 1000);
    } else {
      setIsAutoUpdate(false);
    }
    
    // Cleanup interval เมื่อ component unmount
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [localStorage.getItem("site"), dateRange]);

  const formatter = (value) => <CountUp end={value} separator="," />;
  return (
    <AntdContent
      style={{
        margin: window.innerWidth < 768 ? "8px 4px" : "24px 16px",
        padding: window.innerWidth < 768 ? 12 : 24,
        minHeight: 360,
        background: colorBgContainer,
        borderRadius: borderRadiusLG,
      }}
    >
      {/* Filter Section */}
      <Card 
        className="mb-2 md:mb-4" 
        title={
          <div className="flex items-center text-sm md:text-base">
            <FilterOutlined className="mr-1 md:mr-2" />
            กรองข้อมูลตามช่วงวันที่
          </div>
        }
        extra={
          window.innerWidth < 768 ? null : (
            <Space>
              <RangePicker
                value={dateRange}
                onChange={handleDateRangeChange}
                format="DD/MM/YYYY"
                placeholder={['วันที่เริ่มต้น', 'วันที่สิ้นสุด']}
                allowClear={false}
              />
              <Button 
                type="primary"
                onClick={handleApplyFilter}
                disabled={!dateRange || !dateRange[0] || !dateRange[1]}
                loading={loading}
              >
                กรองข้อมูล
              </Button>
              <Button 
                icon={<ReloadOutlined />} 
                onClick={handleResetFilter}
                disabled={!dateRange}
              >
                รีเซ็ต
              </Button>
            </Space>
          )
        }
      >
        {/* Mobile filter controls */}
        {window.innerWidth < 768 && (
          <div className="mb-3 space-y-2">
            <RangePicker
              value={dateRange}
              onChange={handleDateRangeChange}
              format="DD/MM/YYYY"
              placeholder={['วันที่เริ่มต้น', 'วันที่สิ้นสุด']}
              allowClear={false}
              size="small"
              className="w-full"
            />
            <div className="flex space-x-2">
              <Button 
                type="primary"
                onClick={handleApplyFilter}
                disabled={!dateRange || !dateRange[0] || !dateRange[1]}
                loading={loading}
                size="small"
                className="flex-1"
              >
                กรองข้อมูล
              </Button>
              <Button 
                icon={<ReloadOutlined />} 
                onClick={handleResetFilter}
                disabled={!dateRange}
                size="small"
              >
                รีเซ็ต
              </Button>
            </div>
          </div>
        )}
        
        <div className="text-gray-600 text-sm md:text-base">
          {error ? (
            <span className="text-red-600">
              ⚠️ {error}
            </span>
          ) : loading ? (
            <span className="text-blue-600">
              <ReloadOutlined spin className="mr-1" />
              กำลังโหลดข้อมูล...
            </span>
          ) : dateRange && dateRange[0] && dateRange[1] ? (
            <span>
              แสดงข้อมูลตั้งแต่: <strong className="text-green-600">{dateRange[0]?.format('DD/MM/YYYY')}</strong> 
              ถึง: <strong className="text-green-600">{dateRange[1]?.format('DD/MM/YYYY')}</strong>
              <span className="ml-2 text-xs text-gray-500">(ข้อมูลถูกกรองแล้ว - ไม่มีการอัปเดตอัตโนมัติ)</span>
            </span>
          ) : (
            <span>
              กรุณาเลือกช่วงวันที่เพื่อกรองข้อมูล
              <span className="ml-2 text-xs text-blue-500">
                {isAutoUpdate ? "(ข้อมูลจะอัปเดตอัตโนมัติทุก 15 วินาที)" : "(ไม่มีการอัปเดตอัตโนมัติ)"}
              </span>
            </span>
          )}
        </div>
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-3">
        <CardMonitor
          title={
            <div className="flex items-center justify-between">
              <div>จำนวนผู้ติดต่อทั้งหมด (คน)</div>
              <div className="w-8 h-8 flex items-center justify-center rounded-[6px] text-black text-[24px]">
                <Download
                  tip={"โหลดรายงานผู้ติดต่อ"}
                  icon={<CloudDownloadOutlined />}
                  status={"vms"}
                />
              </div>
            </div>
          }
          color={"#FFC13F"}
          icon={<TeamOutlined />}
          description={
            <div className="text-[28px]">
              {loading ? (
                <div className="animate-pulse">กำลังโหลด...</div>
              ) : (
                totalVMS.length == 1000 ? "1000+" : formatter(totalVMS.length)
              )}
            </div>
          }
          actions={
            <VMSList
              title={"จำนวนผู้ติดต่อทั้งหมด (คน)"}
              data={totalVMS}
              destination={dataList}
            />
          }
        />
        <CardMonitor
          title={"จำนวนผู้ติดต่อ (คน)"}
          color={"green"}
          icon={<TeamOutlined />}
          description={
            <div className="text-[28px]">
              {loading ? (
                <div className="animate-pulse">กำลังโหลด...</div>
              ) : (
                formatter(data["ผู้มาติดต่อ"] || 0)
              )}
            </div>
          }
          actions={<VMSList title={"ผู้มาติดต่อ"} data={todayVMS} destination={dataList} />}
        />
        <CardMonitor
          title={"จำนวนผู้ติดต่อที่ยังไม่ออกพื้นที่ (คน)"}
          color={"#FF0000"}
          icon={<TeamOutlined />}
          description={
            <div className="text-[28px]">
              {loading ? (
                <div className="animate-pulse">กำลังโหลด...</div>
              ) : (
                formatter(data["ยังอยู่ในพื้นที่"] || 0)
              )}
            </div>
          }
          actions={
            <VMSList
              title={"จำนวนผู้ติดต่อที่ยังไม่ออกพื้นที่ (คน)"}
              data={notExitVMS}
              destination={dataList}
            />
          }
        />
      </div>
      <div className="grid grid-cols-3 gap-3 mt-5">
        {template?.map((item, index) => (
          <CardMonitor
            key={index}
            title={Object.keys(item)[0]}
            color={"#000000"}
            icon={<TeamOutlined />}
            description={
              <div className="text-[28px]">
                {loading ? (
                  <div className="animate-pulse">กำลังโหลด...</div>
                ) : (
                  formatter(data[Object.keys(item)[0]] || 0)
                )}
              </div>
            }
            actions={
              <VMSList
                title={Object.keys(item)[0]}
                data={dataList[Object.keys(item)[0]]}
              />
            }
          />
        ))}
      </div>
      {/* <div className="mt-4 grid grid-cols-1 gap-1">
        <CardMonitor
          title={
            <div className="flex justify-between">
              <div>สถิติการเข้ามาติดต่อ</div>
              <Select
                className="ml-4"
                showSearch
                style={{ width: 200 }}
                placeholder="ปีปัจจุบัน"
                options={[
                  { value: "1", label: "เดือนปัจจุบัน" },
                  { value: "2", label: "เดือนก่อน" },
                  { value: "3", label: "2 เดือน" },
                  { value: "4", label: "3 เดือน" },
                  { value: "5", label: "6 เดือน" },
                  { value: "6", label: "1 ปี" },
                  { value: "6", label: "ปีปัจจุบัน" },
                  { value: "6", label: "ปีก่อน" },
                ]}
              />
            </div>
          }
          actions={
            <div className="w-[80vw]">
              <DemoColumn />
            </div>
          }
        />
      </div> */}
    </AntdContent>
  );
};

export default ContentComp;
